<div style="display: flex; flex-direction: row; width: 100%; height: 100%;">

  <!-- Left vertical title strip (matches all other dialog panels) -->
  <div class="dialog-title-container">
    <div class="dialog-title-text">{{ panelTitle | translate }}</div>
  </div>

  <!-- Right content area -->
  <div class="cb-content tab-container app-dark-bg">

    <!-- Search row -->
    <div class="cb-search-row">
      <div class="cb-field">
        <label>{{ 'churchbook.lbl_field' | translate }}</label>
        <select [(ngModel)]="selectedField">
          <option *ngFor="let f of fields" [value]="f.value">{{ f.label | translate }}</option>
        </select>
      </div>
      <div class="cb-value">
        <label>{{ 'churchbook.lbl_value' | translate }}</label>
        <select *ngIf="isEnumField" [(ngModel)]="selectedEventType">
          <option [ngValue]="null" disabled>{{ 'churchbook.lbl_field' | translate }}</option>
          <option *ngFor="let et of eventTypeEntries" [ngValue]="et.value">{{ et.label }}</option>
        </select>
        <input *ngIf="!isEnumField"
               [(ngModel)]="searchValue"
               (keyup.enter)="search()"
               maxlength="200"
               [placeholder]="'churchbook.lbl_value' | translate" />
      </div>
      <div class="cb-search-btn-wrap">
        <button class="ft-btn ft-btn-active" (click)="search()" [disabled]="isLoading">{{ 'lbl_search' | translate }}</button>
      </div>
    </div>

    <!-- Smart Import -->
    <div class="cb-action-row">
      <button class="cb-btn-outline" (click)="openComingSoon()">&#x2193; {{ 'churchbook.lbl_smart_import' | translate }}</button>
    </div>

    <!-- Error -->
    <div class="cb-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

    <!-- Loading spinner (initial load) -->
    <div class="cb-loading" *ngIf="isLoading && !results.length">
      <div class="cb-spinner"></div>
    </div>

    <!-- Results area -->
    <ng-container *ngIf="searched && (!isLoading || results.length)">

      <div class="cb-results-label" *ngIf="totalCount > 0">
        {{ totalCount }} {{ 'churchbook.lbl_results_found' | translate }}
      </div>

      <!-- Person cards -->
      <ng-container *ngIf="searchType === 'person'">
        <div class="cb-card" *ngFor="let p of personResults; trackBy: trackByResultId">
          <div class="cb-card-name">{{ p.full_name }}</div>
          <div class="cb-card-meta">
            <span *ngIf="p.birth_date">{{ 'churchbook.lbl_born' | translate }} {{ p.birth_date }}</span>
            <span *ngIf="p.birthplace">&nbsp;&middot; {{ p.birthplace }}</span>
            <ng-container *ngIf="p.parent_info?.father || p.parent_info?.mother">
              <br />
              <span *ngIf="p.parent_info?.father">{{ 'lbl_father' | translate }}: {{ p.parent_info.father }}</span>
              <span *ngIf="p.parent_info?.father && p.parent_info?.mother">&nbsp;&middot;&nbsp;</span>
              <span *ngIf="p.parent_info?.mother">{{ 'lbl_mother' | translate }}: {{ p.parent_info.mother }}</span>
            </ng-container>
          </div>
          <div class="cb-card-badges">
            <span class="cb-badge">{{ p.events_count }} {{ 'lbl_event' | translate | lowercase }}</span>
            <span class="cb-badge cb-badge-grey">{{ p.families_count }} {{ 'lbl_family' | translate | lowercase }}</span>
          </div>
        </div>
      </ng-container>

      <!-- Family cards -->
      <ng-container *ngIf="searchType === 'family'">
        <div class="cb-card" *ngFor="let f of familyResults; trackBy: trackByResultId">
          <div class="cb-card-name">{{ f.family_name }}</div>
          <div class="cb-card-meta">
            {{ 'churchbook.lbl_surname' | translate }}: {{ f.surname }}&nbsp;&middot; {{ 'churchbook.lbl_root_person' | translate }}: {{ f.root_person_name }}
          </div>
          <div class="cb-card-members">
            <span class="cb-chip" *ngFor="let m of f.members">
              {{ m.full_name }} <em>{{ m.role }}</em>
            </span>
          </div>
          <div class="cb-card-badges">
            <span class="cb-badge">{{ f.member_count }} {{ 'lbl_member' | translate | lowercase }}</span>
          </div>
        </div>
      </ng-container>

      <!-- Event cards -->
      <ng-container *ngIf="searchType === 'event'">
        <div class="cb-card" *ngFor="let e of eventResults; trackBy: trackByResultId">
          <div class="cb-card-name">{{ getEventTypeLabel(e.event_type) }}</div>
          <div class="cb-card-meta">
            <span *ngIf="e.event_date">{{ e.event_date }}</span>
            <span *ngIf="e.parish">&nbsp;&middot; {{ e.parish }}</span>
            <span *ngIf="e.location">&nbsp;&middot; {{ e.location }}</span>
          </div>
          <div class="cb-card-badges">
            <span class="cb-badge">{{ e.participant_count }}</span>
            <span class="cb-badge cb-badge-grey">p.&nbsp;{{ e.registry_page }}</span>
          </div>
        </div>
      </ng-container>

      <!-- Load more -->
      <button class="cb-btn-load-more" *ngIf="hasMore" (click)="loadMore()" [disabled]="isLoading">
        {{ isLoading ? ('churchbook.lbl_loading' | translate) : ('churchbook.lbl_load_more' | translate) }}
      </button>

      <!-- No results -->
      <div class="cb-no-results" *ngIf="!isLoading && totalCount === 0">
        <div class="cb-no-results-icon">&#x1F4D6;</div>
        <div class="cb-no-results-title">{{ 'churchbook.lbl_no_records_found' | translate }}</div>
        <div class="cb-no-results-msg">{{ 'churchbook.lbl_no_records_msg' | translate }}</div>
        <button class="cb-coming-soon-btn" (click)="openComingSoon()">{{ 'churchbook.lbl_more_data_coming_soon' | translate }}</button>
      </div>

      <!-- Further Features (shown when results exist) -->
      <button class="cb-coming-soon-btn" *ngIf="totalCount > 0" (click)="openComingSoon()">
        {{ 'churchbook.lbl_further_features' | translate }}
      </button>

    </ng-container>

    <!-- Coming Soon popup -->
    <div class="cb-overlay" *ngIf="showComingSoon" (click)="closeComingSoon()">
      <div class="cb-popup" (click)="$event.stopPropagation()">
        <div class="cb-popup-hdr">
          <span>{{ 'churchbook.lbl_coming_soon' | translate }}</span>
          <button class="cb-popup-close" (click)="closeComingSoon()">&#x2715;</button>
        </div>
        <div class="cb-popup-body">
          <div class="cb-popup-emoji">&#x1F680;</div>
          <h3>{{ 'churchbook.lbl_coming_soon_title' | translate }}</h3>
          <p>{{ 'churchbook.lbl_coming_soon_msg' | translate }}</p>
          <button class="ft-btn ft-btn-active" (click)="closeComingSoon()">{{ 'churchbook.lbl_got_it' | translate }}</button>
        </div>
      </div>
    </div>

  </div>
</div>
